import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import constants from 'Constants';
import AccountStore from 'stores/Model/Account/AccountStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class BillingDetailsStore {

  @setter @observable id;
  @setter @observable account;
  @setter @observable stripeCustomerId;
  @setter @observable stripePaymentMethodId;
  @setter @observable stripeEmail;
  @setter @observable invoiceDetails;
  @setter @observable paymentDisplay;

  @setter @observable hasStartedTrial;
  @setter @observable numTrialDaysLeft;
  @setter @observable isMissingPaymentMethod;

  static create(data={}) {
    const instance = new BillingDetailsStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "account": new AccountStore(),
      "stripeCustomerId": "",
      "stripePaymentMethodId": "",
      "stripeEmail": "",
      "invoiceDetails": "",
      "paymentDisplay": "",

      "hasStartedTrial": false,
      "numTrialDaysLeft": "",
      "isMissingPaymentMethod": false,
    };
  }

  constructor(defaults=BillingDetailsStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=BillingDetailsStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "account", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": AccountStore},
      {"field": "stripeCustomerId", "accessor": "stripe_customer_id"},
      {"field": "stripePaymentMethodId", "accessor": "stripe_payment_method_id"},
      {"field": "stripeEmail", "accessor": "stripe_email"},
      {"field": "invoiceDetails", "accessor": "invoice_details"},
      {"field": "paymentDisplay", "accessor": "payment_display"},

      {"field": "hasStartedTrial", "accessor": "has_started_trial"},
      {"field": "numTrialDaysLeft", "accessor": "num_trial_days_left"},
      {"field": "isMissingPaymentMethod", "accessor": "is_missing_payment_method"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}


export default BillingDetailsStore;


